// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"navGroup_root__VFq29","navList":"navGroup_navList__NeQO4"};